<div class="app-es-ocr-quick-fix-seller-consignee-details">
  <div class="app-es-ocr-quick-fix-seller-consignee-details__row">
    <app-section-form-block-layout
      *ngIf="!!filteredSellerFields"
      [formGroup]="sellerFg"
      headerTitle="LABELS.SELLER"
      [isInvalid]="isSellerInvalid"
      [isHeaderTitleUpperCase]="true"
      editBlockDescription="INFO.SE.SUB_TITLE_DESKTOP"
      infoTooltip="INFO.SE.SUB_TITLE_DESKTOP"
      [fields]="filteredSellerFields"
      [displayFields]="sellerDisplayFields"
      [displayErrors]="sellerDisplayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(sellerFields, sellerFg)"
      editBlockClass="normal-gap"
    >
      <app-control-wrapper edit-block-body [control]="sellerFg.get('name')" [isShowHelper]="false" [errors]="sellerDisplayErrors">
        <label for="name" control-label>{{ "LABELS.NAME" | translate }}</label>
        <app-search-wrapper control-wrapper [items]="entities" [loading]="companyLoading" (callback)="changeAddress($event)">
          <input
            type="text"
            [formControl]="sellerFg.get('name')"
            class="form-control"
            id="name"
            name="name"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          />
        </app-search-wrapper>
      </app-control-wrapper>

      <address-update
        edit-block-body
        [formGroup]="sellerFg"
        [code]="enumEntityModelCode.SELLER"
        [errors]="formErrors"
        [isShowState]="isShowSellerState"
        [isShowCountry]="false"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <div class="app-es-ocr-quick-fix-seller-consignee-details__row">
    <app-section-form-block-layout
      *ngIf="!!consigneeFields"
      [formGroup]="consigneeFg"
      headerTitle="ENTITY.CONSIGNEE"
      [isInvalid]="isConsigneeInvalid"
      [isHeaderTitleUpperCase]="true"
      infoTooltip="ENTITY.CONSIGNEE"
      [fields]="consigneeFields"
      [displayFields]="consigneeDisplayFields"
      [displayErrors]="consigneeDisplayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(consigneeFields, consigneeFg)"
      editBlockClass="normal-gap"
    >
      <div edit-block-body>
        <identifier-entity-update
          [formGroup]="consigneeFg"
          [code]="enumEntityModelCode.CONSIGNEE"
          [type]="enumEntityType.buyer"
          [errors]="formErrors"
          [identifierFieldName]="'entityIdentifier'"
          [identifierQualifierFieldName]="'entityIdentifierQualifier'"
          [needUpdateValidators]="true"
        ></identifier-entity-update>
        <address-update
          [formGroup]="consigneeFg"
          [code]="enumEntityModelCode.CONSIGNEE"
          [errors]="formErrors"
          [isShowState]="true"
          [isShowCountry]="false"
          [isDesktop]="true"
          [defaultCountry]="null"
          [isFilterRestrictedCountries]="false"
        ></address-update>
      </div>

      <div display-block-footer class="row" *ngIf="!!this.consigneeIsSameAsImporter">
        <div class="col-12">
          <div class="app-es-ocr-quick-fix-seller-consignee-details__entity-is-same-as">
            <i>=</i>
            {{ this.consigneeIsSameAsImporter }}
          </div>
        </div>
      </div>
    </app-section-form-block-layout>
  </div>

  <div class="app-es-ocr-quick-fix-seller-consignee-details__row">
    <app-section-form-block-layout
      *ngIf="!!buyerFields"
      [formGroup]="buyerFg"
      headerTitle="ENTITY.BUYER"
      [isInvalid]="isBuyerInvalid"
      [isHeaderTitleUpperCase]="true"
      infoTooltip="ENTITY.BUYER"
      [fields]="buyerFields"
      [displayFields]="buyerDisplayFields"
      [displayErrors]="buyerDisplayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(buyerFields, buyerFg)"
      editBlockClass="normal-gap"
    >
      <div edit-block-body>
        <identifier-entity-update
          [formGroup]="buyerFg"
          [code]="enumEntityModelCode.BUYER"
          [type]="enumEntityType.buyer"
          [errors]="formErrors"
          [identifierFieldName]="'entityIdentifier'"
          [identifierQualifierFieldName]="'entityIdentifierQualifier'"
          [needUpdateValidators]="true"
        ></identifier-entity-update>
        <address-update
          [formGroup]="buyerFg"
          [code]="enumEntityModelCode.BUYER"
          [errors]="formErrors"
          [isShowState]="true"
          [isShowCountry]="false"
          [isDesktop]="true"
          [defaultCountry]="null"
          [isFilterRestrictedCountries]="false"
        ></address-update>
      </div>

      <div display-block-footer class="row" *ngIf="!!buyerIsSameAsImporter">
        <div class="col-12">
          <div class="app-es-ocr-quick-fix-seller-consignee-details__entity-is-same-as">
            <i>=</i>
            {{ buyerIsSameAsImporter }}
          </div>
        </div>
      </div>
    </app-section-form-block-layout>
  </div>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
